import {extractDomainByLevel} from '@tplatform/common';

const PASSPORT_HOST = 'passport.yandex-team.ru';

export const getPassportHost = (hostname = window.location.hostname) => {
    const secondLevelDomain = extractDomainByLevel(hostname, 2);

    if (!secondLevelDomain) {
        return `https://${PASSPORT_HOST}`;
    }

    return `https://passport.${secondLevelDomain}`;
};
